import URI from "urijs";
import IHeaderMenuItem from "../models/IHeaderMenuItem";
import { normalizeUri } from "./normalizeUri";
import getUrl from "./getUrl";

const isHeaderMenuItemSelected = (item: IHeaderMenuItem): boolean => {
  if (item.alwaysSelected) {
    return true;
  }

  const itemHref = normalizeUri(getUrl(item.href));
  const curHref = normalizeUri(
    URI(window.location.href)
      .resource()
      .toLowerCase(),
  );

  if (curHref === itemHref) {
    return true;
  }

  if (item.startsWith && curHref.startsWith(normalizeUri(getUrl(item.startsWith)))) {
    return true;
  }
  return false;
};

export default isHeaderMenuItemSelected;
